window.QuickbuyDrawer = (() => {
  if (typeof window.QuickbuyDrawer !== "undefined") {
    return window.QuickbuyDrawer;
  }
  
  const selector = {
    drawer: ".js-quickbuy-drawer",
    productImage: ".quickbuy-product-image",
    productTitle: ".quickbuy-product-title",
    productOptions: ".quickbuy-product-options",
    addToCartButton: ".quickbuy-add-to-cart-button",
    quickbuyButton: ".js-card-product__quickbuy",
    closeButton: ".drawer-close-button",
    imageContainer: ".quickbuy-product-image-container",
    productVendor: ".quickbuy-product-vendor",
  };

  let selectedVariant = null;
  let currentProduct = null;

  const addToCart = async (variantId) => {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!response.ok) {
        console.error(
          "Cart add response not OK:",
          response.status,
          response.statusText
        );
      }
    } catch (err) {
      console.error("Add to cart error:", err);
    }
  };

  const openDrawer = () => {
    const drawer = document.querySelector(selector.drawer);
    const overlay = document.querySelector(".js-drawer-overlay");
    if (drawer) {
      drawer.classList.add("open");
    }
    if (overlay) {
      overlay.classList.add("open");
    }
  };

  const closeDrawer = () => {
    const drawer = document.querySelector(selector.drawer);
    const overlay = document.querySelector(".js-drawer-overlay");
    if (drawer) {
      drawer.classList.remove("open");
    }
    if (overlay) {
      overlay.classList.remove("open");
    }
  };

  const populateOptions = (product, container) => {
    if (!product || !container) return;

    // Clear existing options
    container.innerHTML = "";

    if (product.variants.length <= 1) {
      return;
    }

    // For products with multiple options, use the dropdown selector
    const template = document.querySelector(
      "#quickbuy-variant-selector-template"
    ).innerHTML;
    container.innerHTML = template;

    const select = container.querySelector(".quickbuy-variant-selector");

    if (select) {
      // Add all variants to select, but disable unavailable ones
      product.variants.forEach((variant) => {
        const option = document.createElement("option");
        option.value = variant.id;

        if (variant.available) {
          option.textContent = variant.title;
        } else {
          const isClearance =
            document.querySelector(selector.quickbuyButton)?.dataset
              .isClearance === "true";
          const soldOutText = isClearance
            ? window.variantTranslations?.unfortunately_sold_out
            : window.variantTranslations?.soon_available;
          option.textContent = `${variant.title} - ${soldOutText}`;
          option.disabled = true;
        }

        select.appendChild(option);
      });
    }
  };

  const populateDrawer = (product) => {
    const drawer = document.querySelector(selector.drawer);
    if (drawer) {
      const productImage = drawer.querySelector(selector.productImage);
      const productTitle = drawer.querySelector(selector.productTitle);
      const productOptions = drawer.querySelector(selector.productOptions);
      const productVendor = drawer.querySelector(selector.productVendor);

      if (productImage) {
        // Find first available variant and use its image
        const firstAvailableVariant = product.variants.find(
          (variant) => variant.available
        );
        const imageUrl =
          firstAvailableVariant?.featured_image?.src || product.featured_image;
        productImage.src = imageUrl;
      }

      if (productTitle) {
        productTitle.textContent = product.title;
      }

      if (productVendor) {
        productVendor.textContent = product.vendor;
      }

      if (productOptions) {
        populateOptions(product, productOptions);
      }
    } else {
      console.error("Drawer element not found");
    }
  };

  const handleClose = () => {
    const drawer = document.querySelector(selector.drawer);
    const closeButton = drawer.querySelector(selector.closeButton);

    // Close when clicking the close button
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        closeDrawer();
      });
    }

    // Close when clicking outside the drawer
    document.addEventListener("click", (event) => {
      const isClickInside = drawer.contains(event.target);
      const isQuickbuyButton = event.target.closest(selector.quickbuyButton);

      if (
        !isClickInside &&
        !isQuickbuyButton &&
        drawer.classList.contains("open")
      ) {
        closeDrawer();
      }
    });
  };

  const getProduct = async (handle) => {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${handle}.js`
      );

      if (!response.ok) {
        console.error(
          `Failed to fetch product: ${response.status} ${response.statusText}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error(`Error fetching product with handle ${handle}:`, error);
    }
  };

  const handleAddToCart = () => {
    const drawer = document.querySelector(selector.drawer);
    const addToCartButton = drawer.querySelector(selector.addToCartButton);
    addToCartButton.addEventListener("click", () => {
      if (selectedVariant) {
        addToCart(selectedVariant);
        closeDrawer();
      }
    });
  };

  const loadImage = (url, imgElement) => {
    return new Promise((resolve, reject) => {
      const tempImage = new Image();
      tempImage.src = url;
      tempImage.onload = () => {
        imgElement.src = url;
        resolve();
      };
      tempImage.onerror = reject;
    });
  };
  const handleVariantChange = () => {
    const drawer = document.querySelector(selector.drawer);
    const productOptions = drawer.querySelector(selector.productOptions);
    const productImage = drawer.querySelector(selector.productImage);
    const imageContainer = drawer.querySelector(selector.imageContainer);

    productOptions.addEventListener("change", (event) => {
      const variantId = event.target.value;
      imageContainer.classList.add("skeleton");

      const variant = currentProduct.variants.find(
        (variant) => variant.id.toString() === variantId.toString()
      );

      if (!variant?.featured_image?.src) {
        console.warn("No featured image found for variant:", variantId);
        return;
      }

      const imageUrl = variant.featured_image.src;
      selectedVariant = variantId;

      loadImage(imageUrl, productImage)
        .then(() => {
          imageContainer.classList.remove("skeleton");
        })
        .catch((error) => {
          console.error("Error loading variant image:", error);
          imageContainer.classList.remove("skeleton");
        });

      productImage.src = imageUrl;
    });
  };

  const handleQuickbuyButtonClick = async (button) => {
    try {
      const product = await getProduct(button.dataset.productHandle);
      currentProduct = product;

      // Check if product has only one variant and it's available
      if (product.variants.length === 1 && product.variants[0].available) {
        // Add to cart directly
        await addToCart(product.variants[0].id);
        return;
      }

      // Otherwise, open drawer and continue with normal flow
      openDrawer();

      const imageElement = document.querySelector(selector.productImage);
      const imageContainer = document.querySelector(selector.imageContainer);
      imageContainer.classList.add("skeleton");

      const imageUrl = product.featured_image;
      await loadImage(imageUrl, imageElement).then(() => {
        imageContainer.classList.remove("skeleton");
      });

      // Find the first available variant (in stock) or default to the first variant
      const firstAvailableVariant =
        product.variants.find((variant) => variant.available) ||
        product.variants[0];
      selectedVariant = firstAvailableVariant.id;

      populateDrawer(product);
    } catch (error) {
      console.error("Error loading product:", error);
    }
  };

  const setupQuickbuyButtons = () => {
    const quickbuyButtons = document.querySelectorAll(selector.quickbuyButton);
    quickbuyButtons.forEach((button) => {
      button.addEventListener("click", () => handleQuickbuyButtonClick(button));
    });
  };

  const init = () => {
    setupQuickbuyButtons();
    handleClose();
    handleAddToCart();
    handleVariantChange();
  };

  document.addEventListener("DOMContentLoaded", init);

  return {
    setupQuickbuyButtons,
  };

})();
